import type { Component } from "solid-js";
import Profile from "./profile";
import Navbar from "./navbar";

const Header: Component = () => {
  return (
    <header class="shadow bg-white dark:bg-[var(--bg-secondary)] pt-4 sticky top-0 z-50">
      <div class="flex items-center justify-between pb-4 px-8">
        <div class="flex-1 font-semibold text-2xl dark:text-white">SIMPEEL</div>

        <Profile />
      </div>

      <Navbar />
    </header>
  );
};

export default Header;
